import React from 'react'
import { View } from 'oio-react'
import { SortableContainer } from 'react-sortable-hoc'
import { TransitionGroup, Transition } from 'react-transition-group'
import FormBuilderCard from '../Card'

const animationDuration = 300

const FormBuilderCardContainer = SortableContainer(({
   elements, onInputChange, onOptionAdd, onOptionChange, onOptionRemove, onOptionSortEnd,
   onPropChange, onRemove, onRequiredChange, setAllowedFileTypes, ref
}) => (
   <View
      ref={ref}
      width="100%"
      height="100%"
      padding="0px 24px[a-c] 0px 60px[d] 0px 78px[e-f]"
      scroll="on">
      <div className="w-full max-w-lg mx-auto">
         <TransitionGroup>
            {elements.map((element, index) => (
               <Transition
                  key={element.id || index}
                  timeout={{
                     appear: 100,
                     enter: 100,
                     exit: animationDuration
                  }}>
                  {(state) => {
                     const isAnimating = state === 'entering' || state === 'exiting'
                     return (
                        <div style={{
                           transition: `${animationDuration}ms ease-in-out`,
                           opacity: isAnimating ? '0' : '1',
                           transform: isAnimating
                              ? 'translateX(120%)'
                              : 'translateX(0)'
                        }}>
                           <FormBuilderCard
                              key={element.id || index}
                              index={index}
                              elementIndex={index}
                              element={element}
                              onInputChange={onInputChange}
                              onOptionAdd={onOptionAdd}
                              onOptionChange={onOptionChange}
                              onOptionRemove={onOptionRemove}
                              onOptionSortEnd={onOptionSortEnd}
                              onPropChange={onPropChange}
                              onRemove={onRemove}
                              onRequiredChange={onRequiredChange}
                              setAllowedFileTypes={element.type === 'file' ? setAllowedFileTypes : null}
                           />
                        </div>
                     )
                  }}
               </Transition>
            ))}
         </TransitionGroup>
      </div>
      <div className="float-left w-full h-40" />
   </View>
))

export default FormBuilderCardContainer
